(function(){
    'use strict';

    angular
    .module('appback')
    .controller('TablonController', TablonController)
 
    TablonController.$inject = ["TablonService","GenerallabService","$http","$timeout","$uibModal", "$log", "$document","$sce","Upload"];
              
    function TablonController(TablonService,GenerallabService,$http,$timeout,$uibModal, $log, $document,$sce,Upload)
    {                         
        var vm = this;
       	vm.cartaModal = "";
        vm.generalLab = GenerallabService;
        vm.getTablon = function(){
        	TablonService.getTablon(function(data){
                vm.todasCartas = data.cartas;
                vm.nuevas = data.nuevas;
        	})
        }

        vm.addComentario = function(item){
            TablonService.addComentario(item,function(data){
                vm.actualizarCarta(data.carta);
            })
        }

         vm.actualizarCarta = function(carta){
         	var res = false;
 			for(var cont=0;cont<vm.todasCartas.length;cont++){
                if(vm.todasCartas[cont].id == carta.id){
                    vm.todasCartas[cont] = carta;
                    res = true;
                }
            }
            if(!res){
            	vm.todasCartas.unshift(carta);
            }
        }

        vm.deleteTablon = function(item,key){
            TablonService.deleteTablon(item.id,function(data){
                if(data.code==1){
                    vm.todasCartas.splice(key,1);
                }
            });
        }

        vm.addTablon = function(item){
        	vm.cartaModal = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'addtablon.html',
                  size: 'md',
                  backdrop:'static',
                  controller: function($scope) {
                    $scope.newCard = {};

                    $scope.uploadFiles = function (files) { 
                        console.log("item",item);
                        if (files && files.length) {
                          for (var i = 0; i < files.length; i++) {
                            Upload.upload({
                                  url: '/backend/site/subirficheros',
                                  data: { file: files[i] }
                              }).then(function (resp) {
                                  //console.log(resp);
                                  if(typeof($scope.newCard.config) == 'undefined'){
                                      $scope.newCard.config = {ficheros:[]};
                                  }
                                  $scope.newCard.config.ficheros.push(resp.data);

                                 if ($scope.newCard.config.ficheros) {
                                  console.log(vm.filesLength = vm.filesLength + 1);
                                  console.log(vm.filesLength);
                                 }
                              }, function (resp) {
                                  //console.log('Error status: ' + resp.status);
                              }, function (evt) {
                                  var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                                  //console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                              });
                          }
                          //files = null;

                        }
                    }

                    if(angular.isDefined(item)){
                        $scope.newCard = angular.copy(item);
                    }
                    $scope.generalLab = vm.generalLab;
                    $scope.okForm = function(){
                        TablonService.nuevoTablon($scope.newCard,function(data){
                			vm.actualizarCarta(data.carta);
                            vm.cartaModal.close();
                        });
                    }

                    $scope.koForm = function(){
                        vm.cartaModal.close();
                    }
                   
                  }
              });
        }
       	
    }
  
})();